"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var modal_1 = require("@reverbdotcom/commons/dist/components/modal");
var price_filters_1 = require("./price_filters");
var bind_1 = require("../../../bind");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var FollowModal = /** @class */ (function (_super) {
    tslib_1.__extends(FollowModal, _super);
    function FollowModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FollowModal, "defaultProps", {
        get: function () {
            return {
                addGearAlert: true,
            };
        },
        enumerable: true,
        configurable: true
    });
    FollowModal.prototype.handleSubmit = function (e) {
        e.preventDefault();
        tracker_1.trackInteraction({
            componentName: 'FollowModal',
            interactionType: tracker_1.SUBMIT,
            context: { gear_alert: this.props.addGearAlert },
        });
        this.props.submit();
    };
    FollowModal.prototype.handleGearAlertChange = function (e) {
        var addGearAlert = e.target.checked;
        this.props.onUpdate({ addGearAlert: addGearAlert });
    };
    FollowModal.prototype.handleUsedOnlyChange = function (e) {
        var usedOnly = e.target.checked;
        this.props.onUpdate({ usedOnly: usedOnly });
    };
    FollowModal.prototype.renderUsedFilter = function () {
        if (!this.props.withUsedFilter) {
            return null;
        }
        return (React.createElement("div", { className: "feed-modal__option" },
            React.createElement("div", { className: "feed-modal__switch" },
                React.createElement("input", { type: "checkbox", id: "used-only-toggle", onChange: this.handleUsedOnlyChange, checked: this.props.usedOnly }),
                React.createElement("label", { htmlFor: "used-only-toggle" }, I18n.t('discovery.addFollowToFeed.usedOnly')))));
    };
    FollowModal.prototype.renderPriceFilters = function () {
        if (!this.props.withPriceFilters) {
            return null;
        }
        return (React.createElement(price_filters_1.default, { onUpdate: this.props.onUpdate, filterByPrice: this.props.filterByPrice, priceMax: this.props.priceMax, priceMin: this.props.priceMin }));
    };
    FollowModal.prototype.renderReadableTitle = function () {
        // guard against empty
        // also guard generic "Gear" titles, until we fix the response for CSPs
        if (!this.props.readableTitle) {
            return null;
        }
        return (React.createElement("small", { className: "feed-modal__header__follow-title" },
            React.createElement(sanitized_render_1.default, { html: I18n.t('discovery.addFollowToFeed.readableTitle', { titleText: this.props.readableTitle,
                    strongOpen: '<strong>',
                    strongClose: '</strong>',
                }) })));
    };
    FollowModal.prototype.render = function () {
        return (React.createElement(modal_1.default, { isOpen: this.props.isOpen, subClass: "feed", onRequestClose: this.props.onRequestClose },
            React.createElement("h1", { className: "feed-modal__header" },
                this.props.headerLabel,
                this.renderReadableTitle()),
            React.createElement("div", { className: "feed-modal__option" },
                React.createElement("div", { className: "feed-modal__switch" },
                    React.createElement("input", { type: "checkbox", id: "gear-alert-toggle", onChange: this.handleGearAlertChange, checked: this.props.addGearAlert, "aria-checked": this.props.addGearAlert }),
                    React.createElement("label", { htmlFor: "gear-alert-toggle" }, I18n.t('discovery.addFollowToFeed.addToGearAlerts')))),
            this.renderUsedFilter(),
            this.renderPriceFilters(),
            React.createElement("div", { className: "feed-modal__action" },
                React.createElement("button", { id: "submit-follow", onClick: this.handleSubmit }, this.props.submitLabel))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], FollowModal.prototype, "handleSubmit", null);
    tslib_1.__decorate([
        bind_1.default
    ], FollowModal.prototype, "handleGearAlertChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], FollowModal.prototype, "handleUsedOnlyChange", null);
    return FollowModal;
}(React.Component));
exports.default = FollowModal;
//# sourceMappingURL=follow_modal.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/feed/follow_modal.js
// module id = ielw
// module chunks = 20 21